import { getWordPressHost } from './getWordPressHost'

export const wordPressHost = getWordPressHost()

/** 將站內路徑解析為完整 WP URL（host／國別前綴依當前 pathname）；非絕對路徑則接在當前頁面後。供 <a href> 等需要實際 URL 之處使用。 */
export const getWordPressUrl = (path: string) =>
  path.startsWith('/') ? `${wordPressHost}${path}` : `${window.location.href}/${path}`

export const wordPressNavigate = (path: string) => {
  window.location.href = getWordPressUrl(path)
}
